import {apiBaseUrlFactory as ApiBaseUrlFactory} from './apiBaseUrl.factory';
import {NotificationService} from './notificationService';
import {StateChangeService} from './stateChangeService';
import { ExceptionalService } from './exceptionalService';
import { CacheService } from './cacheService';
import { MetatagService } from './metatagService';

import './filters/bootstrap';
import './sessions/bootstrap';


import 'angular-material/angular-material.scss';
import 'angular-material-data-table/dist/md-data-table.css';

import './styles/site.scss';
import './messageService';
var appModule = angular.module('deliveryCreate.app');
appModule.name = name;

appModule.factory('ApiBaseUrlFactory', ApiBaseUrlFactory);
appModule.service('NotificationService', NotificationService);
appModule.service('CacheService', CacheService);
appModule.service('StateChangeService', StateChangeService);
appModule.service('ExceptionalService', ExceptionalService);
appModule.service('MetatagService', MetatagService);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/bootstrap.ts
 **/